import RA1 from "../assets/RA1.png";
import RA2 from "../assets/RA2.png";
import RA3 from "../assets/RA3.png";
import PA1 from "../assets/PA1.png";
import PA2 from "../assets/PA2.png";
import PA3 from "../assets/PA3.png";
import PA4 from "../assets/PA4.png";
import PA5 from "../assets/PA5.png";
import MA1 from "../assets/MA1.png";
import MA2 from "../assets/MA2.png";
import MA3 from "../assets/MA3.png";
import MA4 from "../assets/MA4.png";
import DA1 from "../assets/DA1.png";
import DA2 from "../assets/DA2.png";
import DA3 from "../assets/DA3.png";
import DA4 from "../assets/DA4.png";
import NA1 from "../assets/NA1.png";
import SA1 from "../assets/SA1.png";
import TA1 from "../assets/TA1.png";
import TA2 from "../assets/TA2.png";
import TA3 from "../assets/TA3.png";
import LA1 from "../assets/LA1.png";
import LA2 from "../assets/LA2.png";
import LA3 from "../assets/LA3.png";
import LA4 from "../assets/LA4.png";
import LA5 from "../assets/LA5.png";



const assets = {
    RA: [RA1, RA2, RA3], //Reader's Attic
    PA: [PA1, PA2, PA3, PA4, PA5], // Portfolio
    MA: [MA1, MA2, MA3, MA4], //Magazine
    NA: [NA1], // NotesApp
    SA: [SA1], //Spotify
    DA: [DA1, DA2, DA3, DA4], //Degrees of Seperation
    TA: [TA1, TA2, TA3], //Tribute Page
    LA: [LA1, LA2, LA3, LA4, LA5], //Legistify
}

export default assets;